module.exports = __webpack_public_path__ + "img/17a001-09.d18466f1.png";